<template>
  <div class="error-text">
    <span><i></i>{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'error-text',
  props: ['text'],
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';

.error-text {
  @include dot;
  position: absolute;
  left: 0;
  top: -50px;
  width: 260px;
  padding: 4px 10px;
  background:rgba(255,59,48,0.1);
  border: 1px solid $errorColor;
  font-size: 14px;
  font-weight:400;
  color:$errorColor;
  line-height: 20px;
  // span {
  //   @include flex;
  //   align-items: center;
  // }
  i {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
    background: url('../imgs/error@2x.png') center no-repeat;
    background-size: 16px auto;
  }
}
</style>
